import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import '@progress/kendo-ui/js/kendo.treelist.js';
import '@progress/kendo-ui/js/kendo.editor.js';
import 'jquery-sparkline/jquery.sparkline.js';
import 'flot/jquery.flot.js';
import 'flot/jquery.flot.resize.js';
import 'flot/jquery.flot.pie.js';
import 'flot/jquery.flot.time.js';
import 'flot/jquery.flot.categories.js';
import 'flot/jquery.flot.stack.js';
import 'flot-axislabels/jquery.flot.axislabels.js';
import 'jquery.flot.tooltip/js/jquery.flot.tooltip.js';

import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NDDActionbarModule } from '@ndk/ng-actionbar';
import { NDDButtonsModule } from '@ndk/ng-buttons';
import { NDDGridAbstractSettingsService } from '@ndk/ng-grid/component/shared/ndd-ng-grid-settings.service';
import { NDDLightGridModule } from '@ndk/ng-light-grid';
import { NDDOffSideScreenModule, NDDOffSideScreenService } from '@ndk/ng-off-side-screen';
import { NDDSpinnerModule } from '@ndk/ng-spinner';
import { NDDTitlebarModule } from '@ndk/ng-titlebar';
import { NDDTranslationModule } from '@ndk/ng-translation';
import { NDDIntlModule, NDDIntlService } from 'ndd-ng-intl';

import { NotAllowDisplayNameGuardService } from '@features/settings/jobs-assignment/display-name/shared/not-allow-display-name-guard.service';
import { SettingsQuotasActivationBehaviorService } from '@features/settings/quotas/activation-behavior/shared/settings-quotas-activation-behavior.service';
import { SettingsQuotasTypeService } from '@features/settings/quotas/type/shared/settings-quotas-type.service';
import { SettingsManagerPermissionsService } from '@features/settings/users/managers/shared/settings-manager-permissions.service';
import { UserService } from '@features/user/shared/user.service';

import { LayoutDefaultGuardService } from './guards/layout-default-guard.service';
import { NotAllowAdministratorsGuardService } from './guards/not-allow-administrators-guard.service';
import { NotAllowDisabledManagementPoliciesQuotasGuardService } from './guards/not-allow-disabled-management-policies-quotas-guard.service';
import { NotAllowLicenseDisabledPoliciesGuardService } from './guards/not-allow-license-disabled-policies-guard.service';
import { NotAllowLocalAccessGuardService } from './guards/not-allow-local-access-guard.service';
import { NotAllowManagerWhenAccountIsPrinterTypeGuardService } from './guards/not-allow-manager-when-account-is-printer-type.service';
import { NotAllowMultiEnterprisesAccessGuardService } from './guards/not-allow-multi-enterprises-access-guard.service';
import { NotAllowPartnerGuardService } from './guards/not-allow-partner-guard.service';
import { NotAllowPartnerRestrictGuardService } from './guards/not-allow-partner-restrict-guard.service';
import { NotAllowUserGuardService } from './guards/not-allow-user-guard.service';
import { ScanFlowDisabledGuardService } from './guards/scan-flow-disabled-guard.service';
import { ScanFlowDisabledOrPermissionGuardService } from './guards/scan-flow-disabled-or-permission-guard.service';
import { SettingsDefaultGuardService } from './guards/settings-default-guard.service';
import { NDDDatasModule } from './ndd-ng-datas/ndd-ng-datas.module';
import { NDDFlotDirective } from './ndd-ng-flot/ndd-ng-flot.directive';
import { NDDFormsModule } from './ndd-ng-forms/ndd-ng-forms.module';
import { NDDSparklineDirective } from './ndd-ng-sparkline/ndd-ng-sparkline.directive';
import { NDDTreeGridComponent } from './ndd-ng-tree-grid/ndd-ng-tree-grid.component';
import { CustomDialogModule } from './overrides/custom-dialog.module';
import { CustomGridSettingsService } from './overrides/custom-grid-settings.service';
import { CustomIntlService } from './overrides/custom-intl.service';
import { CustomOffsideScreenService } from './overrides/custom-offside-screen.service';
import { PageReloadComponent } from './page-reload/page-reload.component';
import { ParameterService } from './parameters/parameter.service';
import { PolicyParameterService } from './parameters/policy-parameter.service';
import { RegionalSettingsService } from './regional-settings/regional-settings.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,

        CustomDialogModule,
        NDDTranslationModule,
        NDDActionbarModule,
        NDDSpinnerModule,
        NDDOffSideScreenModule,
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule, // FIXME: Importado no novo módulo de formulário.
        ReactiveFormsModule, // FIXME: Importado no novo módulo de formulário.

        NDDTranslationModule,
        NDDIntlModule,
        NDDButtonsModule,
        NDDDatasModule,
        NDDFormsModule,
        NDDOffSideScreenModule,
        NDDSpinnerModule,
        NDDTitlebarModule,
        CustomDialogModule,
        NDDLightGridModule,

        PageReloadComponent,
        NDDTreeGridComponent,
        NDDSparklineDirective,
        NDDFlotDirective,
    ],
    declarations: [
        PageReloadComponent,
        NDDTreeGridComponent,
        NDDSparklineDirective,
        NDDFlotDirective,
    ],
    providers: [
        SettingsManagerPermissionsService,
        SettingsQuotasActivationBehaviorService,
        UserService,
        SettingsQuotasTypeService,
        NotAllowUserGuardService,
        NotAllowAdministratorsGuardService,
        NotAllowPartnerRestrictGuardService,
        NotAllowPartnerGuardService,
        NotAllowDisplayNameGuardService,
        NotAllowDisabledManagementPoliciesQuotasGuardService,
        NotAllowLocalAccessGuardService,
        NotAllowLicenseDisabledPoliciesGuardService,
        NotAllowMultiEnterprisesAccessGuardService,
        NotAllowManagerWhenAccountIsPrinterTypeGuardService,
        LayoutDefaultGuardService,
        SettingsDefaultGuardService,
        ScanFlowDisabledGuardService,
        ScanFlowDisabledOrPermissionGuardService,

        DecimalPipe,
        DatePipe,
        {
            provide: NDDIntlService,
            useClass: CustomIntlService,
        },
        {
            provide: NDDOffSideScreenService,
            useClass: CustomOffsideScreenService,
        },
        RegionalSettingsService,
        ParameterService,
        PolicyParameterService,
        {
            provide: NDDGridAbstractSettingsService,
            useClass: CustomGridSettingsService,
        },
    ],
})
export class SharedModule { }
